import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import 'normalize.css/normalize.css'
import '@/assets/less/global.less'
import '@/assets/less/antd-theme.less'
import '@/assets/css/index.css'
import '@/assets/less/smart-them.less'
import 'vue3-video-play/dist/style.css'
import '@vue-flow/core/dist/style.css'
import '@vue-flow/core/dist/theme-default.css'
import mitt from 'mitt'
import registerDirectives from './directives'
import lazyImage from './directives/custom/lazy'
import { getVersionType, setVersionType } from '@/utils/checkStatus'
import { cleanupServiceWorker } from '@/utils/serviceWorkerCleanup'
import { watchAppVersion, watchChunkLoadError } from '@/utils/appUpdate'
import VMdPreview from '@kangc/v-md-editor/lib/preview'
import '@kangc/v-md-editor/lib/style/preview.css'
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js'
import '@kangc/v-md-editor/lib/theme/style/github.css'
import hljs from 'highlight.js'

VMdPreview.use(githubTheme, {
  Hljs: hljs
})

const app = createApp(App)
const store = createPinia()
app.config.globalProperties.$EventBus = new mitt()

if (!getVersionType()) {
  setVersionType('common') // 默认设置版本类型为专业版
}
registerDirectives(app)
app.directive('lazy', lazyImage)

app.use(VMdPreview)
app.use(store).use(router).mount('#app')
// 告诉 public/index.html 里的白屏兜底脚本：应用已成功挂载，不要再显示「浏览器版本过低」
window.__SOLO_APP_MOUNTED__ = true

/* 清理历史版本注册过的 Service Worker 与其预缓存。
   旧 SW 会命中 index.html 的预缓存直接返回，导致请求到不了 nginx、
   服务端配置的重定向对老用户失效。放在 mount 之后执行，不阻塞首屏。 */
cleanupServiceWorker()

/* 发版后的自动更新：懒加载失败兜底 + 版本号轮询，替代原先由 SW 承担的自动刷新 */
watchChunkLoadError(router)
watchAppVersion()
